import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { SpinnerService } from '../../../services/spinner.service';
import { DownloadService } from '../../../services/download.service';
import { SnackbarService } from '../../../services/snackbar.service';
import {
  AportacionDIPoseedorDTO,
  AportacionDIPoseedorPayloadDTO,
  AportacionDIEstadoControllerService,
  AportacionDIPoseedorControllerService,
  OperacionGestionControllerService,
  SolicitudCodigoLerDTO,
  SolicitudNimaGestoresDTO,
  SolicitudNimaPoseedorDTO,
  AportacionDIEstadoDTO,
  CodigoOperacionFilterDTO,
  AportacionDITarifaImporteDTO,
  ParametrosControllerService,
  ResiduoEnvasePayloadDTO,
  ResiduoEnvaseControllerService,
  PoseedorDTO,
  PoseedorControllerService,
  CodigoLerFilterDTO,
  CodigoLerControllerService,
  PageDTOCodigoLerDTO,
  CodigoLerDTO
} from 'api-rest';
import { Observable, Subscription, tap, map, catchError, of } from 'rxjs';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { DocumentService } from '../../../services/document.service';
import moment, { invalid } from 'moment';
import { HoldersContributionsDisImageDialogComponent } from '../holders-contributions-dis-image-dialog/holders-contributions-dis-image-dialog.component';
import swal from 'sweetalert2';

import { HoldersContributionsDisDeclineDialogComponent } from '../holders-contributions-dis-cancel-dialog/holders-contributions-dis-cancel-dialog.component';
import { HoldersContributionsDisPreviewDialogComponent } from '../holders-contributions-dis-preview-dialog/holders-contributions-dis-preview-dialog.component';

@Component({
  selector: 'app-holders-contributions-dis-dialog',
  templateUrl: './holders-contributions-dis-dialog.component.html',
  styleUrls: ['./holders-contributions-dis-dialog.component.scss'],
})
export class HoldersContributionsDisDialogComponent implements OnInit {
  estadoArray: AportacionDIEstadoDTO[] = [];
  codigoLerArray: any[] = [];
  documentoArray: any[] = [];
  residuoArray: any[] = [];
  descripcionEnvaseArray: any[] = [];
  gestionArray: any[] = [];
  nimaPoseedorArray: any[] = [];
  nimaGestorArray: any[] = [];
  entityRoles: any[] = [];

  modelForm!: FormGroup;
  uipathForm!: FormGroup;
  subscriptions: Subscription[] = [];
  roleEntities: any[] = [];
  documento: File | undefined;
  titulo: any;
  isGestor = false;
  isPoseedor = false;
  edicion = false;
  alta = false;
  estado: Number = 1;
  cargaCombos: boolean = true;

  tipoAcceso: string | null = null;
  pageNumber: number = 0;
  pageSize: number = 100;
  recordsTotal: number = 0;
  fechaLimite: Date | undefined;
  poseedorInfo: PoseedorDTO | undefined;
  creacionResiduoEnvase: boolean = false;
  codigosLerEndpoint : CodigoLerDTO[] = [];

  operacionGestionEndpoint: string = this.environment.urlBackPoseedores + `api/v1/poseedores/operacion-gestion/codigo-operacion`;
  updateList: boolean = false;
  defaultOperacionesGestionParameters: any = {codigoLer: [null], poseedores: true}

  get styleEstadoAportaciones(): { 'background-color': string; 'color': string } {
    const estadoId = this.aportacion?.estado?.id;
    switch (estadoId) {
      case 1: return { 'background-color': '#F49D33', 'color': '#ffffff' };
      case 2: return { 'background-color': '#F49D33', 'color': '#ffffff' };
      case 3: return { 'background-color': '#86BC25', 'color': '#ffffff' };
      case 4: return { 'background-color': '#773E90', 'color': '#ffffff' };
      case 5: return { 'background-color': '#A7A6A6', 'color': '#ffffff' };
      case 10: return { 'background-color': '#5FC3E1', 'color': '#ffffff' };
      case 7: return { 'background-color': '#B80F61', 'color': '#ffffff' };
      case 8: return { 'background-color': '#080C35', 'color': '#ffffff' };
      case 9: return { 'background-color': '#004A99', 'color': '#ffffff' };
      default: return { 'background-color': '#ffffff', 'color': '#080C35' };
    }
  }
    get iconEstado() {
    return this.aportacion?.estado?.id === 3 ? 'check_circle' : 'warning_amber';
  }
  constructor(
    @Inject('environment') private environment: any,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private dialogRef: MatDialogRef<HoldersContributionsDisDialogComponent>,
    private estadoAportacionesService: AportacionDIEstadoControllerService,
    private aportacionesDiService: AportacionDIPoseedorControllerService,
    private downloadService: DownloadService,
    private documentService: DocumentService,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    @Inject(MAT_DIALOG_DATA) public aportacion: AportacionDIPoseedorDTO | any,
    private operacionGestionControllerService: OperacionGestionControllerService,
    private parametrosControllerService: ParametrosControllerService,
    private residuoEnvaseControllerSrv: ResiduoEnvaseControllerService,
    private poseedorControllerSrv: PoseedorControllerService,
    private codigoLerControllerService: CodigoLerControllerService,
  ) {
    
    this.tipoAcceso = aportacion?.tipoAcceso ?? null;

    if (aportacion?.poseedor) {
      this.isPoseedor = true;
      this.comboCodigoLer();
    } else {
      this.isGestor = true;
    }
    
    this.inicializarForm();
    this.inicializarFormUipath();
    this.defaultOperacionesGestionParameters = {codigoLer: [this.modelForm.get('codigoLer')?.value?.id ?? null], poseedores: true};
  }

  ngOnInit() {
    this.cargaInicial();
    if (this.isEdicionMode()) {
      this.dialogRef.updateSize('1425px', undefined);
    }
  }

  comboCodigoLer() {
    const backendFilter: CodigoLerFilterDTO = {};
    this.codigoLerControllerService
      .findAll4(backendFilter, { page: 0, size: 100 })
      .subscribe({
        next: (data: PageDTOCodigoLerDTO) => {
          this.codigosLerEndpoint = data?.datos!;
        },
        error: () => {},
      });
  }
  inicializarForm() {
    if (this.aportacion?.esAportacionSDDRCA) {
      this.aportacion.origen = 'SDDRCA';
    } else if (this.aportacion && !this.aportacion.origen) {
      this.aportacion.origen = 'POSEEDOR';
    }
    this.aportacion.fechaAceptacion;
    //Si es nueva aportacion, inicializar la fecha aceptacion con la fecha actual, sino, mantenerla vacia
    if(this.aportacion.id){
      //detalle de aportacion
      this.aportacion.fechaAceptacion = this.aportacion.fechaAceptacion;
    }else{
      //nueva aportacion
      this.aportacion.fechaAceptacion = this.aportacion.fechaAceptacion ?? new Date().toISOString();
    }
    if (this.aportacion.gestorResiduo == null && this.aportacion.nimaGestor != null && this.aportacion.nimaGestor != '') {
      this.aportacion.gestorResiduo = {
        nima: this.aportacion.nimaGestor
      }
    }
    if (this.aportacion.gestorResiduo == null && this.aportacion.nimaGestor != null && this.aportacion.nimaGestor != '') {
      this.aportacion.gestorResiduo = {
        nima: this.aportacion.nimaGestor
      }
    }
    this.modelForm = this.formBuilder.group({
      id: [{ value: this.aportacion?.id }],
      documentoIdentificacion: [
        { value: this.aportacion?.documentoIdentificacion, disabled: false },
        { validators: Validators.compose([Validators.required, Validators.maxLength(255)]) },
      ],
      fechaAceptacion: [
        { value: this.aportacion?.fechaAceptacion, disabled: false },
        { validators: Validators.compose([Validators.required, this.customValidator()]) },
      ],
      fechaAportacion: [
        { value: this.aportacion?.fechaAportacion, disabled: true },
      ],
      estado: [{ value: this.aportacion?.estado, disabled: false }],

      poseedor: [
        { value: this.aportacion?.poseedor, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      nimaGestor: [
        { value: this.aportacion?.gestorResiduo, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],

      autofactura: [{ value: null, disabled: false }],
      documento: [{ value: this.aportacion?.documento , disabled: false }],
      

      codigoLer: [
        { value: this.aportacion?.codigoLer, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      gestorResiduo: [
        { value: this.aportacion?.gestorResiduo, disabled: false },
      ],
      operacionGestion: [
        { value: this.aportacion?.operacionGestion, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],

      cantidadGestionada: [
        { value: this.aportacion?.cantidadGestionada, disabled: false },
        { validators: Validators.compose([Validators.required, Validators.min(0.000000001)]) },
      ],
      esAportacionSDDRCA: [
        { value: this.aportacion?.esAportacionSDDRCA, disabled: false },
      ],
      importeTotal: [{ value: null, disabled: true }],
      tarifaAplicada: [{ value: null, disabled: true }],
      confirmacionDatos: [
        { value: null, disabled: false },
        //{ validators: Validators.compose([Validators.required]) }
      ],
      esCreadoPoseedor: [{ value: this.isPoseedor, disabled: false },],
      subirDocumentoOnEdit: [
        { value: false, disabled: false },
        //  { validators: Validators.compose([Validators.required]) },
      ],
    });
          if (this.aportacion.estado.id === 7 || this.aportacion.estado.id === 1 || this.aportacion.estado.id === 10) {
            this.comboCodigoLer();
      }
    this.modelForm.get('operacionGestion')?.valueChanges.subscribe((val) => {
      // Sólo cuando la selección la hace el usuario (los cambios programáticos no marcan el control como dirty)
      if (!val || !this.modelForm.get('operacionGestion')?.dirty) return;
      this.avisarCombinacionBidon(val);
    });
        
    const codigoLerControl = this.modelForm.get('codigoLer');
    codigoLerControl?.valueChanges.subscribe((val) => {
      /* logic moved to valueChangeCodigoLer */
    });
    this.modelForm.get('poseedor')?.valueChanges.subscribe((val) => {
      if (this.aportacion.estado.id === 7 || this.aportacion.estado.id === 1 || this.aportacion.estado.id === 10) {
        if (this.aportacion.poseedor !== null && this.aportacion.poseedor !== undefined && this.aportacion.poseedor !== '') {
          this.poseedorInfo = this.aportacion.poseedor;
        }
        else if (this.modelForm.get('poseedor')?.value !== null && this.modelForm.get('poseedor')?.value !== undefined && this.modelForm.get('poseedor')?.value !== '' && this.modelForm.get('poseedor')?.value.id !== null && this.modelForm.get('poseedor')?.value.id !== undefined && this.modelForm.get('poseedor')?.value.id !== '') {
          this.poseedorInfo = this.modelForm.get('poseedor')?.value;
        }
          
      }
      

    });
    if ((this.aportacion?.estado.id === 7 || this.aportacion?.estado.id === 1 || this.aportacion?.estado.id === 10) && this.aportacion?.poseedor && this.aportacion.esCreadoPoseedor !== false) {
        if (this.aportacion.poseedor !== null && this.aportacion.poseedor !== undefined && this.aportacion.poseedor !== '') {
          this.poseedorInfo = this.aportacion.poseedor;
        }
        else if (this.modelForm.get('poseedor')?.value !== null && this.modelForm.get('poseedor')?.value !== undefined && this.modelForm.get('poseedor')?.value !== '' && this.modelForm.get('poseedor')?.value.id !== null && this.modelForm.get('poseedor')?.value.id !== undefined && this.modelForm.get('poseedor')?.value.id !== '') {
          this.poseedorInfo = this.modelForm.get('poseedor')?.value;
          //this.poseedorInformacion().subscribe();
        }
    }

        

      
    //this.valueChangeCodigoLer();
  }

  private avisarCombinacionBidon(operacion: any): void {
    if (![1, 7, 10].includes(this.aportacion?.estado?.id)) return;
    const lerId = this.modelForm.controls['codigoLer'].value?.id;
    let material: string;
    let codigoLerBidon: string;
    if (operacion.codigo === 'R0309' && lerId === 11) {
      material = 'plástico';
      codigoLerBidon = 'LER24';
    } else if (operacion.codigo === 'R0404' && lerId === 12) {
      material = 'metal';
      codigoLerBidon = 'LER23';
    } else {
      return;
    }
    Swal.fire({
      text: `Esta selección de datos se considera un “15 01 10* - Envase peligroso de ${material} de tipo Bidón”. Si acepta, el código LER se cambiará por el de bidón.`,
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.cambiarLerBidon(operacion, codigoLerBidon);
      }
    });
  }

  private cambiarLerBidon(operacion: any, codigoLerBidon: string): void {
    const seleccionado = this.codigosLerEndpoint.find((x) => x.codigo === codigoLerBidon);
    const poseedor = this.modelForm.get('poseedor')?.value;
    if (!seleccionado || !poseedor) {
      this.snackBarSrv.showSnackBar('No se ha podido cambiar el código LER a bidón', 'error');
      return;
    }
    const residuo: ResiduoEnvasePayloadDTO = {
      codigoLer: seleccionado,
      operacionGestion: operacion,
      nimaGestor: this.modelForm.controls['nimaGestor'].value?.nima,
      previsionCantidadGenerada: 0,
      suministradorInformacion: 'Poseedor',
      anioDatos: new Date().getFullYear(),
    };
    const validar = () => {
      residuo.poseedor = this.poseedorInfo;
      this.validarOperacionGestion(residuo, seleccionado.id);
    };
    if (!this.poseedorInfo || this.poseedorInfo.id !== poseedor.id) {
      this.poseedorInformacion().subscribe(() => validar());
    } else {
      validar();
    }
  }

  // El setValue sin emitir evento no refresca tarifa ni operaciones de gestión del nuevo LER
  private sincronizarLerBidon(lerId?: number): void {
    this.defaultOperacionesGestionParameters = {codigoLer: [lerId ?? null], poseedores: true};
    this.updateList = !this.updateList;
    this.cargarTarifaImporte();
  }

  guardarPrevision(residuo: ResiduoEnvasePayloadDTO | any,id?:number): void {
    this.spinnerSrv.loadingShow();
    this.residuoEnvaseControllerSrv.create3(residuo).subscribe({
      next: (response: PoseedorDTO) => {
        this.spinnerSrv.loadingHide();
        this.residuoEnvaseControllerSrv
          .comprobarNimaGestor(response.id!)
          .subscribe({
            next: (resultado: any) => {
              residuo.existeNima = resultado;
              /*if (resultado === false) {
                let mensaje = 'Este gestor no está registrado en ENVANET. Le recomendamos que le informe de que debe registrarse, en caso de delegarle el suministro de información por la correcta gestión de sus envases.';
                this.snackBarSrv.showSnackBar(
                  mensaje,
                  'warning'
                );
              }*/
              
              //Reiniciar formulario: evitar que el valueChanges borre operacionGestion
              this.creacionResiduoEnvase = true;
              this.buscaCodigoLer(
                this.modelForm.value?.fechaAceptacion,
                this.modelForm.value?.nimaGestor,
                this.modelForm.value?.poseedor,
                false
              );
              this.modelForm.controls['codigoLer'].setValue({ id: id }, { emitEvent: false });
              this.sincronizarLerBidon(id);

              this.modelForm.markAsPristine();
              this.modelForm.markAsUntouched();
              this.creacionResiduoEnvase = false;
            },
            error: (error: any) => {},
          });
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
        /*this.snackBarSrv.showSnackBar(
          'Ha ocurrido un error al guardar la previsión de residuos',
          'error'
        );*/ 
      },
    });
  }
  poseedorInformacion() {
    this.spinnerSrv.loadingShow();
    return this.poseedorControllerSrv.getById2(this.modelForm.controls['poseedor'].value?.id).pipe(
      tap((response) => {
        this.spinnerSrv.loadingHide();
        this.poseedorInfo = response;
      }),
      catchError((err) => {
        this.spinnerSrv.loadingHide();
        /*this.snackBarSrv.showSnackBar('Ha ocurrido un error al cargar el poseedor', 'error');*/
        return of(null);
      })
    );
  }
  validarOperacionGestion( residuo: ResiduoEnvasePayloadDTO | any,id?:number) {
        if (
          this.poseedorInfo?.residuosEnvase &&
          this.poseedorInfo?.residuosEnvase?.length > 0
        ) {
          let observables: any[] = [];
    
          let residuosFiltrados = this.poseedorInfo?.residuosEnvase.filter(
            (x: any) => x.anioDatos == new Date().getFullYear()
          );
          if (residuosFiltrados?.length > 0) {
            const existe = residuosFiltrados.find(
              (x) =>
                x.anioDatos === new Date().getFullYear() &&
                x.codigoLer?.id === id &&
                x.operacionGestion?.id ===
                this.modelForm.get('operacionGestion')?.value?.id &&
                x.nimaGestor === this.modelForm.get('nimaGestor')?.value?.nima &&
                x.poseedor?.id ==
                this.modelForm.get('poseedor')?.value?.id &&
                x.suministradorInformacion ===
                'Poseedor'
            );
          
          if (existe) {
            /*this.snackBarSrv.showSnackBar(
              'Ya existe la previsión de residuos de envases introducida',
              'error'
            );*/
            // Evitar que el valueChanges borre operacionGestion en este setValue programático
            this.creacionResiduoEnvase = true;
            this.buscaCodigoLer(
              this.modelForm.value?.fechaAceptacion,
              this.modelForm.value?.nimaGestor,
              this.modelForm.value?.poseedor,
              false
            );
            this.modelForm.controls['codigoLer'].setValue({ id: id }, { emitEvent: false });
            this.sincronizarLerBidon(id);
            this.creacionResiduoEnvase = false;
          }else {
            this.guardarPrevision(residuo,id);
          }
          }  
    
        } else {
          this.guardarPrevision(residuo,id);
        }
  }
  assignEvents() {
    const sub = this.modelForm.controls[
      'fechaAceptacion'
    ].valueChanges.subscribe((val) => {
      if (val != null) {
        this.buscarNimaGestor(val, this.modelForm.value?.poseedor);
        this.buscarNimaPoseedor(val, this.modelForm.value?.nimaGestor);
        this.buscaCodigoLer(
          val,
          this.modelForm.value?.nimaGestor,
          this.modelForm.value?.poseedor
        );
        //this.gestionArray = [];
      }

    });
    const sub2 = this.modelForm.controls['poseedor'].valueChanges.subscribe(
      (val) => {
        if(this.modelForm.value?.fechaAceptacion != null){
          this.buscarNimaGestor(this.modelForm.value?.fechaAceptacion, val);
          this.buscaCodigoLer(
            this.modelForm.value?.fechaAceptacion,
            this.modelForm.value?.nimaGestor,
            val
          );
        }
      }
    );
    const sub3 = this.modelForm.controls['nimaGestor'].valueChanges.subscribe(
      (val) => {
        if(this.modelForm.value?.fechaAceptacion != null){
          this.buscarNimaPoseedor(this.modelForm.value?.fechaAceptacion, val);
          this.buscaCodigoLer(
            this.modelForm.value?.fechaAceptacion,
            val,
            this.modelForm.value?.poseedor
          );
        }
      }
    );
    this.subscriptions.push(sub);
    this.subscriptions.push(sub2);
    this.subscriptions.push(sub3);
  }

  inicializarFormUipath() {
    //if (this.aportacion?.id) {
      //this.aportacion.fechaAceptacionUipath = this.aportacion.fechaAceptacionUipath ?? new Date().toISOString();
      let gestorUipath;
      if(this.aportacion?.gestorResiduoReferenceUipath){
        gestorUipath = `${this.aportacion?.gestorResiduoReferenceUipath.nima || ''}${this.aportacion?.gestorResiduoReferenceUipath.razonSocial ? ' - ' + this.aportacion?.gestorResiduoReferenceUipath.razonSocial : ''}${this.aportacion?.gestorResiduoReferenceUipath.centro ? ' - ' + this.aportacion?.gestorResiduoReferenceUipath.centro : ''}`;
      }else if(this.aportacion?.nimaGestorUipath){
        gestorUipath = this.aportacion?.nimaGestorUipath;
      }
      let poseedorUipath;
      if(this.aportacion?.poseedorReferenceUipath){
        poseedorUipath =  `${this.aportacion?.poseedorReferenceUipath.nima} - ${this.aportacion?.poseedorReferenceUipath.razonSocial} - ${this.aportacion?.poseedorReferenceUipath.denominacionCentro}`;
      }else if(this.aportacion?.nimaPoseedorUipath){
        poseedorUipath = this.aportacion?.nimaPoseedorUipath;
      }
      let codLerUipath;
      if(this.aportacion?.codigoLerReferenceUipath){
        codLerUipath =  `${this.aportacion?.codigoLerReferenceUipath.tipoCodigo} - ${this.aportacion?.codigoLerReferenceUipath.descripcion}`;
      }else if(this.aportacion?.codigoLerUipath || this.aportacion?.descripcionCodigoLerUipath){
        codLerUipath = `${this.aportacion?.codigoLerUipath} - ${this.aportacion?.descripcionCodigoLerUipath}`;
      }
      let operUipath;
      if(this.aportacion?.operacionGestionReferenceUipath){
        operUipath =  `${this.aportacion?.operacionGestionReferenceUipath.codigo} - ${this.aportacion?.operacionGestionReferenceUipath.descripcion}`;
      }else if(this.aportacion?.codigoOperacionUipath || this.aportacion?.descripcionOperacionUipath){
        operUipath = `${this.aportacion?.codigoOperacionUipath} - ${this.aportacion?.descripcionOperacionUipath}`;
      }
      this.uipathForm = this.formBuilder.group({
        id: [{ value: this.aportacion?.id }],
        documentoIdentificacionUipath: [ { value: this.aportacion?.documentoIdentificacionUipath, disabled: true }],
        fechaAceptacionUipath: [{ value: this.aportacion?.fechaAceptacionUipath, disabled: true }],
        poseedorUipath: [{ value: poseedorUipath, disabled: true }],
        nimaGestorUipath: [{ value: gestorUipath, disabled: true }],
        codigoLerUipath: [ { value: codLerUipath, disabled: true }],
        operacionGestionUipath: [  { value: operUipath,  disabled: true }],
        cantidadGestionadaUipath: [{ value: this.aportacion?.cantidadGestionadaUipath, disabled: true }],
      });

      this.uipathForm.disable();
    //}
  }
  
  cargaInicial() {
    this.roleEntities = (this.authService.user as any).roleEntities;
    if (this.aportacion?.id) {
      this.titulo = 'Editar aportación de DI/FS';
      this.buscarOperacionesGestion();
      this.edicion = true;
    } else {
      this.titulo = 'Alta de aportación de DI/FS';
      this.edicion = false;
    }

    this.cargaCombos = true;
    if (!this.canSaveAll()) {
      if(!this.canUpdateEstadoPdteRevision() && !this.canAccessRevisarAportacion() && !this.gestorEnvaloraCanEditAportacion()){
        this.modelForm.disable();
        this.cargaCombos = false;
      }else{
        if(this.canAccessRevisarAportacion() && !this.gestorEnvaloraCanEditAportacion()){
          this.modelForm.get('confirmacionDatos')?.setValidators(Validators.compose([Validators.required]));
          this.modelForm.get('confirmacionDatos')?.updateValueAndValidity();
        }else{
          this.modelForm.get('confirmacionDatos')?.disable();
        }
        
      }
    }

    if (this.gestorEnvaloraCanEditAportacion()) {
      this.modelForm.get('subirDocumentoOnEdit')?.setValidators(Validators.compose([Validators.required]));
      this.modelForm.get('subirDocumentoOnEdit')?.updateValueAndValidity();
    } else {
      this.modelForm.get('subirDocumentoOnEdit')?.clearValidators();
      this.modelForm.get('subirDocumentoOnEdit')?.updateValueAndValidity();
    }

    this.estadoAportacionesService
      .findAll14()
      .subscribe((estados) => (this.estadoArray = estados));
    const rolesGestor = this.roleEntities?.filter(
      (roleEntity) => roleEntity.role == 'PO-GESTOR'
    );
    const rolesPoseedor = this.roleEntities?.filter(
      (roleEntity) => roleEntity.role == 'PO-POSEEDOR'
    );
    if(this.cargaCombos && this.modelForm.value?.fechaAceptacion != null){

      this.buscarNimaGestor(
        this.modelForm.value?.fechaAceptacion,
        this.aportacion.poseedor
      );
      this.buscarNimaPoseedor(
        this.modelForm.value?.fechaAceptacion,
        this.aportacion.gestorResiduo
      );
      this.buscaCodigoLer(
        this.modelForm.value?.fechaAceptacion,
        this.aportacion.gestorResiduo,
        this.aportacion.poseedor,
        false
      );
      this.buscarFechaLimite()
    } else {
      //La aportacion no se va a editar, por lo que no tiene sentido cargar los combos con todos los datos disponibles
      //Se cargan los datos con lo que tiene el detalle
      if (this.aportacion?.poseedor) {
        this.nimaPoseedorArray.push(this.aportacion?.poseedor);
        this.setItemSelected('poseedor', 'id', this.nimaPoseedorArray, false);
      }
      if (this.aportacion?.gestorResiduo) {
        this.nimaGestorArray.push(this.aportacion?.gestorResiduo);
        this.setItemSelected('nimaGestor', 'nima', this.nimaGestorArray, false);
      }
      if (this.aportacion?.codigoLer) {
        this.codigoLerArray.push(this.aportacion?.codigoLer);
        this.setItemSelected('codigoLer', 'id', this.codigoLerArray, false);
      }
      if (this.aportacion?.operacionGestion) {
        this.gestionArray.push(this.aportacion?.operacionGestion);
        this.setItemSelected('operacionGestion', 'id', this.gestionArray, false);
      }
      this.cargarTarifaImporte();
    }

    //this.buscarGestorResiduos();

    this.updateDisableField('documentoIdentificacion', false);
    this.updateDisableField('fechaAceptacion');
    this.updateDisableField('cantidadGestionada');
    this.updateDisableField('operacionGestion');
    if(this.edicion){
      // this.modelForm.get('esAportacionSDDRCA')?.disable();
    }

    if(this.cargaCombos){
      this.assignEvents();
      this.valueChangeCodigoLer();
      this.valueChangeCantidadGest();
    }
  }

  /*buscarInicialGestor(): Observable<any> {
    return this.gestorResiduos
      .getById3(this.aportacion?.gestorResiduo?.id)
      .pipe(
        tap((res) => {
          this.aportacion.gestorResiduo = res;
        })
      );
  }

  buscarInicialPoseedor(): Observable<any> {
    return this.poseedorService
      .getById2(this.aportacion?.poseedor?.id)
      .pipe(tap((res) => (this.aportacion.poseedor = res)));
  }*/

  updateDisableField(field: any, alsoRevisada: boolean = true): void {
    if (this.aportacion.estado) {
      if (!this.canAccessEditEstado() && (!alsoRevisada || (alsoRevisada && !this.canUpdateEstadoPdteRevision())) && (!this.gestorEnvaloraCanEditAportacion)) {
        this.modelForm.get(field)?.disable();
      }
    }
  }

  buscarNimaGestor(fechaAceptacion: any, poseedor: any, emitEvent: boolean = false) {

    if(this.canViewRol('PO-ENV-GEST') && this.aportacion?.estado?.id === 10 && !this.aportacion?.esCreadoPoseedor){
      this.nimaGestorArray = [this.aportacion.gestorResiduo];
      this.setItemSelected('nimaGestor', 'nima', this.nimaGestorArray, emitEvent);
      return; 
    }
    
    const filtroNimaGestor: SolicitudNimaGestoresDTO = {
      fechaAceptacion: fechaAceptacion,
      poseedor: poseedor,
      origenSDDRCA: this.modelForm.get('esAportacionSDDRCA')?.value,
      menuAportacionModuloPoseedores: this.tipoAcceso ?? undefined,
    };
    this.spinnerSrv.loadingShow();

    if(this.canViewRol('PO-ENV-GEST') && this.aportacion?.estado?.id === 10 ){
      this.aportacionesDiService.nimaGestoresEdicion(filtroNimaGestor).subscribe({
        next: (res) => {
          this.nimaGestorArray = res;
          if (this.aportacion && this.aportacion.gestorResiduo && this.nimaGestorArray.filter((item: any) => item.nima == this.aportacion.gestorResiduo.nima).length == 0 && !this.aportacion?.esCreadoPoseedor) {
            this.nimaGestorArray.push(this.aportacion.gestorResiduo);
          }
          this.setItemSelected('nimaGestor', 'nima', this.nimaGestorArray, emitEvent);
          
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
    }else{
      this.aportacionesDiService.nimaGestores(filtroNimaGestor).subscribe({
        next: (res) => {
          this.nimaGestorArray = res;
          if (this.aportacion && this.aportacion.gestorResiduo && this.nimaGestorArray.filter((item: any) => item.nima == this.aportacion.gestorResiduo.nima).length == 0) {
            this.nimaGestorArray.push(this.aportacion.gestorResiduo);
          }
          this.setItemSelected('nimaGestor', 'nima', this.nimaGestorArray, emitEvent);
          
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
    }
  }

  buscarNimaPoseedor(fechaAceptacion: any, nimaGestor: any, emitEvent: boolean = false) {
    if(this.canViewRol('PO-ENV-GEST') && this.aportacion?.estado?.id === 10 && this.aportacion?.esCreadoPoseedor){
      this.nimaPoseedorArray = [this.aportacion.poseedor];
      this.setItemSelected('poseedor', 'id', this.nimaPoseedorArray, emitEvent);
      return; 
    }
    const filtroNimaPoseedor: SolicitudNimaPoseedorDTO = {
      fechaAceptacion: fechaAceptacion,
      gestor: nimaGestor,
      menuAportacionModuloPoseedores: this.tipoAcceso ?? undefined,
    };

    
    this.spinnerSrv.loadingShow();
        if(this.canViewRol('PO-ENV-GEST') && this.aportacion?.estado?.id === 10 && !this.aportacion?.esCreadoPoseedor){
          this.aportacionesDiService.nimaPoseedoresEdicion(filtroNimaPoseedor).subscribe({
            next: (res) => {
              this.nimaPoseedorArray = res;
              if (this.aportacion && this.aportacion.poseedor && this.nimaPoseedorArray.filter((item: any) => item.nima == this.aportacion.poseedor.nima).length == 0) {
                this.nimaPoseedorArray.push(this.aportacion.poseedor);
              }
              this.setItemSelected('poseedor', 'id', this.nimaPoseedorArray, emitEvent);

          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
    }else{

      this.aportacionesDiService.nimaPoseedores(filtroNimaPoseedor).subscribe({
        next: (res) => {
          this.nimaPoseedorArray = res;
          this.setItemSelected('poseedor', 'id', this.nimaPoseedorArray, emitEvent);
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
    }
  }

  buscaCodigoLer(fechaAceptacion: any, gestorResiduo: any, poseedor: any, emitEvent: boolean = true) {
    if (fechaAceptacion && gestorResiduo && poseedor) {
      const filtroNimaPoseedor: SolicitudCodigoLerDTO = {
        fechaAceptacion: fechaAceptacion,
        gestor: gestorResiduo,
        poseedor: poseedor,
        origenSDDRCA: this.modelForm.get('esAportacionSDDRCA')?.value
      };
      this.spinnerSrv.loadingShow();
      this.aportacionesDiService.codigoLer(filtroNimaPoseedor).subscribe({
        next: (res) => {
          this.codigoLerArray = res;
          this.setItemSelected('codigoLer', 'id', this.codigoLerArray, emitEvent);
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
    } else {
      this.codigoLerArray = [];
      this.gestionArray = [];
    }
  }

  //buscarGestorResiduos() {
  //  const filtroResiduo: ResiduoEnvaseFilterDTO = {};
  //  this.spinnerSrv.loadingShow();
  //  this.gestorResiduos
  //    .findAll8(filtroResiduo, { page: 0, size: 1000 })
  //    .subscribe({
  //      next: (res) => {
  //        this.residuoArray = res?.datos ?? [];
  //        this.setItemSelected('gestorResiduo', 'id', this.residuoArray, false);
  //        this.updateDisableField('gestorResiduo');
  //        this.spinnerSrv.loadingHide();
  //      },
  //      error: () => {
  //        this.spinnerSrv.loadingHide();
  //      },
  //    });
  //}

  valueChangeCodigoLer() {
    this.modelForm.get('codigoLer')?.valueChanges.subscribe((value: any) => {
      if (value) {
        if (!this.creacionResiduoEnvase && (this.aportacion.estado.id === 7 || this.aportacion.estado.id === 1 || this.aportacion.estado.id === 10)) {
          if (this.modelForm.get('codigoLer')?.dirty) {
            this.modelForm.controls['operacionGestion'].reset();
          }
        }
        this.defaultOperacionesGestionParameters = {codigoLer: [value?.id ?? null], poseedores: true};
        this.updateList = !this.updateList;
        // this.buscarOperacionesGestion();
        this.cargarTarifaImporte();
      } else {
        this.defaultOperacionesGestionParameters = {codigoLer: [null], poseedores: true};
        this.gestionArray = [];
        this.modelForm.controls['operacionGestion'].reset();
      }
    });

    // Forzar carga inicial si hay valor preestablecido
    const initialLer = this.modelForm.get('codigoLer')?.value;
    if (initialLer) {
      this.defaultOperacionesGestionParameters = {codigoLer: [initialLer.id ?? null], poseedores: true};
      this.updateList = !this.updateList;
      // this.buscarOperacionesGestion();
    }
  }

  buscarOperacionesGestion() {
    const { backendFilter, page, size } = this.getBackendFilter();
    this.spinnerSrv.loadingShow();
    this.operacionGestionControllerService
      .findByCodigoOperacion(backendFilter, { page: page, size: size })
      .subscribe({
        next: (res) => {
          if (res) {
            this.gestionArray = res?.datos ?? [];
            this.creacionResiduoEnvase = true;
            this.setItemSelected('operacionGestion', 'id', this.gestionArray, false);
            this.updateDisableField('operacionGestion');
          }
          this.spinnerSrv.loadingHide();
          this.creacionResiduoEnvase = false;
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  valueChangeCantidadGest() {
    this.modelForm.get('cantidadGestionada')?.valueChanges.subscribe((value: any) => {
      if (value) {
        const tarifa = this.modelForm.get('tarifaAplicada')?.value;
        const importeTotal = Math.round(tarifa * value * 100) / 100;
        this.modelForm.get('importeTotal')?.setValue(importeTotal);
      } else {
        this.modelForm.get('importeTotal')?.setValue(0);
      }
    });
  }

  cargarTarifaImporte(){
    if(this.modelForm.get('codigoLer')?.value){
      let aporTarifaImporte: AportacionDITarifaImporteDTO = {
        codigoLerID: this.modelForm.get('codigoLer')?.value?.id,
        anio: new Date(this.modelForm.get('fechaAceptacion')?.value).getFullYear(),
        cantidad: this.modelForm.get('cantidadGestionada')?.value ? this.modelForm.get('cantidadGestionada')?.value : 0
      };
      if(new Date(this.modelForm.get('fechaAceptacion')?.value).getFullYear() !== 1970){
      this.aportacionesDiService.cargarPrevision(aporTarifaImporte)
      .subscribe({
          next: (res) => {
            if(res){
              this.modelForm.get('importeTotal')?.setValue(res.importeAportacion);
              this.modelForm.get('tarifaAplicada')?.setValue(res.importeTarifa);
            }
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            console.log(err);
          },
        });
    }else{
      this.modelForm.get('importeTotal')?.setValue(0);
      this.modelForm.get('tarifaAplicada')?.setValue(0);
    }
  }
    
  }

  private getBackendFilter() {
    const backendFilter: CodigoOperacionFilterDTO = {
      codigoLer: [this.modelForm.get('codigoLer')?.value?.id],
      poseedores: true
    };
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;

    return { backendFilter, page, size: this.pageSize };
  }

  private setItemSelected(
    controlName: string,
    propertyName: string,
    items: any[],
    emitEvent: boolean
  ) {
    let selectedItem = null;
    if (this.modelForm.value[controlName]) {
      if (
        typeof this.modelForm.value[controlName] == 'object' &&
        this.modelForm.value[controlName][propertyName]
      ) {
        selectedItem = items.find(
          (item) =>
            this.modelForm.value[controlName][propertyName] ==
            item[propertyName]
        );
      } else {
        selectedItem = items.find(
          (item) => this.modelForm.value[controlName] == item[propertyName]
        );
      }
    }
    this.modelForm.controls[controlName].patchValue(selectedItem, {
      emitEvent: emitEvent,
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

 buttonSaveData(estadoId: any) {
    this.modelForm.markAllAsTouched();
    this.modelForm.updateValueAndValidity();

    if (this.aportacion?.documento == null) {
      if (this.documento == undefined || this.documento == null) {
        this.snackBarSrv.showSnackBar('Adjunte documento', 'error');
        return;
      }
    }

    if (this.modelForm.valid) {
      const todayDate = new Date();
      const fechaAceptacion = new Date(this.modelForm.get('fechaAceptacion')?.value);
      if(fechaAceptacion > todayDate){
        this.snackBarSrv.showSnackBar(
          'La fecha de aceptación no puede ser posterior a la fecha actual.',
          'error'
        );
        return;
      }
      const cantidadGest = this.modelForm.get('cantidadGestionada')?.value;
        if(cantidadGest && cantidadGest < 100){
          swal.fire({
            text: 'Por favor, verifique que el valor introducido en la cantidad neta gestionada es correcto y está en las unidades correspondientes (Kg)',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Guardar',
            denyButtonText: 'Cancelar',
            allowOutsideClick: false,
          }).then((result: any) => {
            if (result.isConfirmed) {
              this.saveData(estadoId);
            }
          });
        }else{
          this.saveData(estadoId);
        }
    }else{
      this.snackBarSrv.showSnackBar('Debe completar los campos obligatorios', 'error');
    }
  }


   saveData(estadoId: any) {
    const aportacionPayload: AportacionDIPoseedorPayloadDTO = this.getAportacionPayload(estadoId);
    let request, successMsg: string, errorMsg: string;
    if (this.aportacion?.id) {
      request = this.aportacionesDiService.editById6(
        this.aportacion.id,
        aportacionPayload,
        this.documento
      );
      successMsg = 'La aportación DI/FS se ha editado correctamente';
      errorMsg = 'Ha ocurrido un error al editar la aportación DI/FS';
    } else {
      if (!this.documento) {
        this.snackBarSrv.showSnackBar(
          'Debe seleccionar un documento',
          'error'
        );
        return;
      }

      request = this.aportacionesDiService.create6(
        aportacionPayload,
        this.documento
      );
      successMsg = 'La aportación DI/FS se ha creado correctamente';
      errorMsg = 'Ha ocurrido un error al crear la nueva aportación DI/FS';
    }

    this.spinnerSrv.loadingShow();
    request.subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.dialogRef.close(true);
        this.snackBarSrv.showSnackBar(successMsg, 'success');
      },
      error: () => {
        if(estadoId != 7 && !this.gestorEnvaloraCanEditAportacion()){
          this.aportacion.estado.id = 1;
        }
        this.spinnerSrv.loadingHide();
      },
    });
  }


  showClearButton(formName: string): boolean {
    return this.modelForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.modelForm.get(formName)?.setValue(null);
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.modelForm.controls[controlName].hasError(errorName) &&
      this.modelForm.controls[controlName].touched
    );
  }

  attachAdjunto(archivo: File | null): void {
    if (archivo) {
      if (archivo.size === 0) {
        this.snackBarSrv.showSnackBar(
          'No se puede subir un fichero vacío',
          'error'
        );
      } else if (archivo.size > 12 * 1024 * 1024) { // 5 MB
        this.snackBarSrv.showSnackBar(
          'El fichero supera el tamaño máximo permitido de 12 MB',
          'error'
        );
      } else {
        this.documento = archivo;
      }
    }
  }

  descargar(documento: any) {
    this.spinnerSrv.loadingShow();
    this.aportacionesDiService.downloadDoc(this.aportacion.id).subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Se ha descargado el documento correctamente',
          'success'
        );
        this.downloadService.downloadBlob(response, documento.nombre);
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
      },
    });
  }

  descargarPrefactura(documento: any) {
    this.spinnerSrv.loadingShow();
    this.aportacionesDiService.downloadDocPrefactura(this.aportacion.id).subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Se ha descargado la prefactura correctamente',
          'success'
        );
        this.downloadService.downloadBlob(response, documento.nombre);
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
      },
    });
  }

  canAccessEditEstado(): boolean {
    return this.aportacion?.estado?.id === 1;
  }

  canAccessEditByRol(): boolean {
    return this.authService.can('poseedores-di-detalle', 'access-update');
  }

  canSaveAll(): boolean {
    if (this.canAccessEditByRol() && this.canAccessEditEstado()) {
      if (
        this.edicion &&
        this.aportacion.creadoPor == this.authService.getCurrentUserMail()
      ) {
        return true;
      } else if (!this.edicion) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  canAccessAcceptAportacion() {
    const resultAccept = this.authService.can('poseedores-di', 'update-accept');
    const estado2 = this.aportacion.estado && (this.aportacion.estado.id === 8 || this.aportacion.estado.id === 5);
    return resultAccept && estado2;
  }

  canAccessCancelAportacion() {
    const resultCancel = this.authService.can('poseedores-di', 'update-cancel');
    const estado2 = this.aportacion.estado && (this.aportacion.estado.id === 3 || this.aportacion.estado.id === 7 || this.aportacion.estado.id === 8);
    return resultCancel && estado2;
  }
  
  canUpdateEstadoPdteRevision(){
    //const estado7 = this.aportacion.estado && this.aportacion.estado.id === 7; //Pdte revision
    //return estado7;
    return this.canAccessRevisarAportacion();
  }

  canAccessRevisarAportacion(){
    const resultRevisar =  this.authService.can('poseedores-di', 'update-revisar');
    const estado7 = this.aportacion.estado && this.aportacion.estado.id === 7; //Pdte revision
    return (resultRevisar && estado7);
  }

  canAccessDeleteAportacion(){
    const resultDelete =  this.authService.can('poseedores-di-detalle', 'delete');
    const estado7 = this.aportacion.estado && this.aportacion.estado.id === 7; //Pdte revision
    return resultDelete && estado7;
  }

  acceptAportacion() {
    this.spinnerSrv.loadingShow();
    this.aportacionesDiService
      .aceptarAportacion(this.aportacion.id)
      .subscribe({
        next: () => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Se ha aceptado la aportación correctamente',
            'success'
          );
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          console.log(err);
        },
      });
  }

  openModalMotivoCancelAportacion() {
    const dialogRef = this.dialog.open(
      HoldersContributionsDisDeclineDialogComponent,
      {
        width: '750px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          info: this.aportacion,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dialogRef.close(true);
      }
    });
  }



  openModalAyuda() {
    const dialogRef = this.dialog.open(
      HoldersContributionsDisImageDialogComponent,
      {
        width: '98%',
        maxWidth: '98%',
        maxHeight: '95vh',
        disableClose: true,
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  vistaPreviaAportacion(element: any) {
    const dialogRef = this.dialog.open(HoldersContributionsDisPreviewDialogComponent, {
      width: '98%',
      maxWidth: '98%',
      maxHeight: '95vh',
      data: element,
      disableClose: true,
    });
  }

  esAportacionSDDRChange(){
    if (this.modelForm.get('esAportacionSDDRCA')?.value) {
      this.aportacion.origen = 'SDDRCA';
    } else {
      this.aportacion.origen = 'POSEEDOR';
    }
    if(this.aportacion.poseedor){
      //buscar gestores en funcion de si es Aportacion del SDDR o no
      this.buscarNimaGestor(
        this.modelForm.value?.fechaAceptacion,
        this.aportacion.poseedor,
        true
      );
    }else{
      //buscar poseedores en funcion de si es Aportacion del SDDR o no
      this.buscarNimaPoseedor(
        this.modelForm.value?.fechaAceptacion,
        this.aportacion.gestorResiduo,
        true
      );
    }
  }
  esPdteRevision(){
    return this.aportacion?.estado.id === 7;
  }

  buscarFechaLimite() {
    this.parametrosControllerService.findAll7().subscribe({
      next: (parametros: any) => {
        const parametro = parametros.find((p: any) => p.id === 1);
        if (parametro?.valor) {
          const [day, month, year] = parametro.valor.split('/');
          this.fechaLimite = new Date(+year, +month - 1, +day); // mes empieza en 0
        } else {
          this.fechaLimite = undefined;
        }
        this.modelForm.get('fechaAceptacion')?.updateValueAndValidity();

      },
      error: (err) => {
        console.error("Error al obtener parámetros", err);
      }
    });
  }

  customValidator() {
    return (control: { value: any }) => {
      const value = control.value;
      if (!value || !this.fechaLimite) {
        return null;
      }

      const fechaIngresada = new Date(control.value);
      
      return fechaIngresada < this.fechaLimite ? { fechaInvalida: true } : null;
    };
  }

 onInput(controlName: string, event: any) {
    const control = this.modelForm.get(controlName)

    control?.markAsTouched();
    control?.markAsDirty();
  }
  openConfirmacionEliminar(): void {
    Swal.fire({
      text: `¿Está seguro de eliminar este registro?
              El documento se eliminará de ENVANET y no podrá volver a consultarlo.`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminarAportacion();
      }
    });
  }

  eliminarAportacion() {
    if (this.aportacion?.id) {
      this.spinnerSrv.loadingShow();
      this.aportacionesDiService
        .deleteAportacionById(this.aportacion?.id)
        .subscribe({
          next: (value: any) => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              `La aportación DI se ha eliminado correctamente.`,
              'success'
            );
            this.dialogRef.close(true);
          },
          error: (err: { message: any }) => {
            this.spinnerSrv.loadingHide();
          },
        });
    }
  }

    getAportacionPayload(estadoId: any){
    const formValue = this.modelForm.value;
    const aportacionPayload: AportacionDIPoseedorPayloadDTO = formValue;
    //aportacionPayload.gestorResiduo = formValue.nimaGestor;
    if(formValue.nimaGestor.id != null && formValue.nimaGestor.id != undefined){
      aportacionPayload.gestorResiduo = formValue.nimaGestor;
      aportacionPayload.nimaGestor = '';
    }else{
      aportacionPayload.nimaGestor = formValue.nimaGestor.nima;
    }
    if (aportacionPayload.estado !== undefined && estadoId !== null) {
      aportacionPayload.estado!.id = estadoId;
    }
    aportacionPayload.fechaAceptacion = moment(aportacionPayload.fechaAceptacion).format('YYYY-MM-DD');
    if(!aportacionPayload.documentoIdentificacion){
      aportacionPayload.documentoIdentificacion = this.modelForm?.get("documentoIdentificacion")?.value;
    }
    if(!aportacionPayload.esAportacionSDDRCA){
      aportacionPayload.esAportacionSDDRCA = false;
    }

    if (aportacionPayload.esAportacionSDDRCA) {
      (aportacionPayload as any).origen = 'SDDRCA';
    } else {
      (aportacionPayload as any).origen = 'POSEEDOR';
    }

  if(formValue.subirDocumentoOnEdit === true){
      aportacionPayload.nuevoDocumento = true;
    }
    return aportacionPayload;
  }

    buttonRevisarAportacion(){
    this.modelForm.markAllAsTouched();
    this.modelForm.updateValueAndValidity();

   if (this.modelForm.valid) {
      const todayDate = new Date();
      const fechaAceptacion = new Date(this.modelForm.get('fechaAceptacion')?.value);
      if(fechaAceptacion > todayDate){
        this.snackBarSrv.showSnackBar(
          'La fecha de aceptación no puede ser posterior a la fecha actual.',
          'error'
        );
        return;
      }
    }

    if (this.modelForm.valid) {
      const cantidadGest = this.modelForm.get('cantidadGestionada')?.value;
      if(cantidadGest && cantidadGest < 100){
        swal.fire({
          text: 'Por favor, verifique que el valor introducido en la cantidad neta gestionada es correcto y está en las unidades correspondientes (Kg)',
          icon: 'question',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: 'Guardar',
          denyButtonText: 'Cancelar',
          allowOutsideClick: false,
        }).then((result: any) => {
          if (result.isConfirmed) {
            this.revisarAportacion();
          }
        });
      }else{
        this.revisarAportacion();
      }
    }else{
      this.snackBarSrv.showSnackBar('Debe completar los campos obligatorios', 'error');
    }
  }


  revisarAportacion(){
    const aportacionPayload: AportacionDIPoseedorPayloadDTO = this.getAportacionPayload(null);
    this.spinnerSrv.loadingShow();
    this.aportacionesDiService.revisarAportacion(this.aportacion.id, aportacionPayload).subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.dialogRef.close(true);
        this.snackBarSrv.showSnackBar('La aportación DI se ha revisado correctamente', 'success');
      },
      error: (error: any) => {
        const backendMessage = error?.error?.arguments?.[0]
        this.snackBarSrv.showSnackBar(
          backendMessage,
          'error'
        );
        this.spinnerSrv.loadingHide();
      },
    });
  }

  esGestorEnvalora(){
    return (this.canViewRol('AD-ENV-GEST') || this.canViewRol('AD-ENV-CONS'));
  }

    canViewRol(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  gestorEnvaloraCanEditAportacion() {
    return (this.esGestorEnvalora() && this.puedeEditarAportacionEstadoCorrecionEnvalora() && this.aportacion?.estado?.id === 10)
  }

  puedeEditarAportacionEstadoCorrecionEnvalora() {
    return this.canViewRol('PO-APORT-EDIC-TOTAL-ENV-GEST');
  }

  isEdicionMode(): boolean {
    return !!(this.aportacion && this.aportacion?.id > 0 && !this.aportacion?.externa);
  }

  fieldDiffers(fieldName: string): boolean {
    if (!this.isEdicionMode() || !this.uipathForm) return false;
    switch (fieldName) {
      case 'documentoIdentificacion': {
        const left = this.modelForm.get('documentoIdentificacion')?.value;
        const right = this.uipathForm.get('documentoIdentificacionUipath')?.value;
        if (!left && !right) return false;
        return this.normalizeString(left) !== this.normalizeString(right);
      }
      case 'fechaAceptacion': {
        const left = this.modelForm.get('fechaAceptacion')?.value;
        const right = this.uipathForm.get('fechaAceptacionUipath')?.value;
        if (!left && !right) return false;
        if (!left || !right) return true;
        return moment(left).format('YYYY-MM-DD') !== moment(right).format('YYYY-MM-DD');
      }
      case 'poseedor': {
        const left = this.modelForm.get('poseedor')?.value;
        const right = this.uipathForm.get('poseedorUipath')?.value;
        if (!left && !right) return false;
        if (!left || !right) return true;
        const leftStr = `${left.nima} - ${left.razonSocial} - ${left.denominacionCentro}`;
        return this.normalizeString(leftStr) !== this.normalizeString(right);
      }
      case 'nimaGestor': {
        const left = this.modelForm.get('nimaGestor')?.value;
        const right = this.uipathForm.get('nimaGestorUipath')?.value;
        if (!left && !right) return false;
        if (!left || !right) return true;
        const leftStr = `${left.nima || ''}${left.razonSocial ? ' - ' + left.razonSocial : ''}${left.centro ? ' - ' + left.centro : ''}`;
        return this.normalizeString(leftStr) !== this.normalizeString(right);
      }
      case 'codigoLer': {
        const left = this.modelForm.get('codigoLer')?.value;
        const right = this.uipathForm.get('codigoLerUipath')?.value;
        if (!left && !right) return false;
        if (!left || !right) return true;
        const leftStr = `${left.tipoCodigo} - ${left.descripcion}`;
        return this.normalizeString(leftStr) !== this.normalizeString(right);
      }
      case 'operacionGestion': {
        const left = this.modelForm.get('operacionGestion')?.value;
        const right = this.uipathForm.get('operacionGestionUipath')?.value;
        if (!left && !right) return false;
        if (!left || !right) return true;
        const leftStr = `${left.codigo} - ${left.descripcion}`;
        return this.normalizeString(leftStr) !== this.normalizeString(right);
      }
      case 'cantidadGestionada': {
        const left = this.modelForm.get('cantidadGestionada')?.value;
        const right = this.uipathForm.get('cantidadGestionadaUipath')?.value;
        const leftEmpty = left === null || left === undefined || left === '';
        const rightEmpty = right === null || right === undefined || right === '';
        if (leftEmpty && rightEmpty) return false;
        if (leftEmpty || rightEmpty) return true;
        return Number(left) !== Number(right);
      }
      default:
        return false;
    }
  }

  private normalizeString(val: any): string {
    if (val === null || val === undefined) return '';
    return val.toString().trim().toLowerCase();
  }

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'operacionGestion': {
        return this.modelForm.get('operacionGestion') as FormControl;
      }
      default: {
        return this.modelForm.get('') as FormControl;
      }
    }
  }

  getOperacionesGestionDescription(obj: any) {
    if (obj) {
      return obj.codigo + ' ' + obj.descripcion;
    }
    return '';
  }

  getOperacionesGestionObjectQuery(searchterm: string) {
    return {
      codigoOrDescripcion: `${searchterm}`,
    };
  }

  compararOperacionesGestion(o1: any, o2: any): boolean {
    return o1?.id === o2?.id;
  }
}